import { store } from '../../store';
import { analyticsApi } from '../../store/api/analyticsApi';

const runFilterQuery = async (endpointName, arg, { emptyFallback = false } = {}) => {
    try {
        const result = await store.dispatch(
            analyticsApi.endpoints[endpointName].initiate(arg, { forceRefetch: true })
        );
        if (result?.error) {
            return emptyFallback;
        }
        return result?.data || emptyFallback;
    } catch (e) {
        return emptyFallback;
    }
};


const getAppType = (pubid, channelid) => {
    return runFilterQuery('getAnalyticsFilterAppType', { pubid, channelid }, { emptyFallback: false });
}


const getSubscriptionList = () => {
    return runFilterQuery('getAnalyticsFilterSubscriptionList', undefined, { emptyFallback: false });
}

const getSubscriptionType = () => {
    return runFilterQuery('getAnalyticsFilterSubscriptionType', undefined, { emptyFallback: false });
}


const getShowList = (pubid, channelid) => {
    return runFilterQuery('getAnalyticsFilterShowList', { pubid, channelid }, { emptyFallback: false });
}

const getCountryList = () => {
    return runFilterQuery('getAnalyticsFilterCountryList', undefined, { emptyFallback: false });
}

const getVideoList = () => {
    return runFilterQuery('getAnalyticsFilterVideoList', undefined, { emptyFallback: false });
}

const getChannelList = (pub_id) => {
    return runFilterQuery('getAnalyticsFilterChannelList', { pub_id }, { emptyFallback: false });
}

const getPublishersList = () => {
    return runFilterQuery('getAnalyticsFilterPublishersList', undefined, { emptyFallback: false });
}

const getCityList = (countryOrParams) => {
    const payload = typeof countryOrParams === 'string'
        ? { country: countryOrParams }
        : (countryOrParams || {});

    const normalizedPayload = {
        ...(payload.country ? { country: payload.country } : {}),
        ...(payload.search ? { search: payload.search } : {}),
        ...(typeof payload.limit === 'number' ? { limit: payload.limit } : {}),
        ...(typeof payload.offset === 'number' ? { offset: payload.offset } : {})
    };

    return runFilterQuery('getAnalyticsFilterCityList', normalizedPayload, { emptyFallback: [] });
}

const getCategoryList = (pubid) => {
    return runFilterQuery('getAnalyticsFilterCategoryList', { pubid }, { emptyFallback: [] });
}

const getdemandSourceList = pub_id => {
    return runFilterQuery('getAnalyticsFilterDemandSourceList', { pub_id }, { emptyFallback: false });
};

function getCouponsList(channelid) {
    return runFilterQuery('getAnalyticsFilterCouponsList', { channelid }, { emptyFallback: false });
}

export const filters = {
    getCountryList,
    getShowList,
    getSubscriptionType,
    getSubscriptionList,
    getAppType,
    getVideoList,
    getChannelList,
    getPublishersList,
    getCityList,
    getCategoryList,
    getdemandSourceList,
    getCouponsList
};
